import { MyUser } from 'libs/end-to-end/src/my-user';
import { DatabaseWithVisibleRevision } from 'libs/end-to-end/src/types/databases/database-with-visible-revision';

type RevisionOptions = {
  label: string;
  value: string;
  model: DatabaseWithVisibleRevision;
  isHidden: boolean;
};

export const getDatabaseRevisionsForUser = ({
  databaseId,
  myUser,
}: {
  databaseId: string;
  myUser: MyUser | null;
}): RevisionOptions[] => {
  if (
    !myUser ||
    !myUser.organization ||
    myUser.organization.databasesWithVisibleRevisions.length === 0
  ) {
    return [];
  }

  if (!databaseId) {
    return [];
  }

  const revisionOptions: RevisionOptions[] = [];

  for (const db of myUser.organization.databasesWithVisibleRevisions) {
    if (db.databaseId === databaseId) {
      revisionOptions.push({
        label: db.revisionName,
        value: db.databaseRevisionId,
        model: db,
        isHidden: db.isHidden,
      });
    }
  }

  return revisionOptions;
};
